export interface JobCountPillProps {
  jobCount?: number
}

export default function JobCountPill({ jobCount }: JobCountPillProps) {
  if (!jobCount) {
    return null
  }
  return (
    <div className="px-1.5 py-1 flex absolute right-[-3%] top-[-36%] lg:top-[-75%] lg:right-[-15%] items-center justify-center min-w-[27px] rounded-full text-orange-2.5 bg-blue-55 text-tiny1">
      {jobCount}
    </div>
  )
}
